var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AuthHeaderV2Component',{attrs:{"currentLayout":"customer-layout","currentUrl":_vm.currentUrl}}),_vm._t("default"),(_vm.displayFooter)?_c('AuthFooterV2Component'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }